"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _codeSnippet = _interopRequireDefault(require("@mapbox/mr-ui/code-snippet"));

var _codeSnippetTitle = _interopRequireDefault(require("../code-snippet-title"));

var _edit = _interopRequireDefault(require("../edit"));

var _themeCss = require("../highlight/theme-css.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CodeSnippet = /*#__PURE__*/function (_React$Component) {
  _inherits(CodeSnippet, _React$Component);

  var _super = _createSuper(CodeSnippet);

  function CodeSnippet() {
    var _this;

    _classCallCheck(this, CodeSnippet);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "editButtons", function () {
      // show edit buttons if edit object and all required props are present
      var edit = _this.props.edit;
      return edit && edit.css && edit.html && edit.js && edit.frontMatter.title && edit.frontMatter.description ? /*#__PURE__*/_react.default.createElement("div", {
        className: "absolute-mm mb6 mb0-mm top right mr36-mm z2",
        style: {
          marginTop: '4px'
        }
      }, /*#__PURE__*/_react.default.createElement(_edit.default, {
        css: edit.css,
        html: edit.html,
        js: edit.js,
        head: edit.head,
        resources: edit.resources,
        frontMatter: edit.frontMatter
      })) : '';
    });

    _defineProperty(_assertThisInitialized(_this), "codeSnippetTitle", function () {
      // show CodeSnippetTitle if filename is present
      var filename = _this.props.filename;
      return filename && /*#__PURE__*/_react.default.createElement(_codeSnippetTitle.default, {
        filename: filename
      });
    });

    return _this;
  }

  _createClass(CodeSnippet, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          code = _this$props.code,
          maxHeight = _this$props.maxHeight,
          highlighter = _this$props.highlighter;
      var highlightedCode = highlighter()(code); // only load the component if we have `code` and `highlighter`

      if (!highlighter && !code) return; // wrap the component in appcontext so we can get the user's token

      return /*#__PURE__*/_react.default.createElement("div", {
        "data-swiftype-index": "false"
      }, this.codeSnippetTitle(), /*#__PURE__*/_react.default.createElement("div", {
        className: "relative prose"
      }, this.editButtons(), /*#__PURE__*/_react.default.createElement(_codeSnippet.default, _extends({
        maxHeight: maxHeight,
        code: code
      }, this.props, {
        highlightThemeCss: _themeCss.highlightThemeCss,
        highlightedCode: highlightedCode,
        onCopy: function onCopy() {
          analytics.track('Copied example with clipboard');
        }
      }))));
    }
  }]);

  return CodeSnippet;
}(_react.default.Component);

CodeSnippet.propTypes = {
  code: _propTypes.default.string.isRequired,
  // raw code
  highlighter: _propTypes.default.func.isRequired,
  // the dr-ui/highlight function, example: highlighter={() => highlightJson}. You must also import the function in your frontmatter.
  filename: _propTypes.default.string,
  // (optional) name of the file to add context to the code block
  maxHeight: _propTypes.default.number,
  // (optional) maximum height of the code block, default is set at 300
  edit: _propTypes.default.shape({
    css: _propTypes.default.string.isRequired,
    // CSS panel contents
    js: _propTypes.default.string.isRequired,
    // JS panel contents
    html: _propTypes.default.string.isRequired,
    // HTML panel contents
    head: _propTypes.default.string,
    // extra html to add to the head of the document (CodePen)
    frontMatter: _propTypes.default.shape({
      title: _propTypes.default.string.isRequired,
      description: _propTypes.default.string.isRequired,
      pathname: _propTypes.default.string.isRequired
    }),
    resources: _propTypes.default.shape({
      // absolute URLs to CDNs
      js: _propTypes.default.array,
      css: _propTypes.default.array
    })
  })
};
var _default = CodeSnippet;
exports.default = _default;